exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-74afc76c]:export{menuText:#bfcbd9;menuActiveText:#409EFF;subMenuActiveText:#f4f4f5;menuBg:#304156;menuHover:#263445;subMenuBg:#1f2d3d;subMenuHover:#001528;sideBarWidth:210px;bgColor:#F2F3F5;fontColor:#409EFF;searchBg:#fff}.process .add-process[data-v-74afc76c]{margin:10px}.select-conditions[data-v-74afc76c]{width:100%;height:150px;padding:20px;background:#fff}.select-conditions-row[data-v-74afc76c]{width:1000px;height:40px;margin:20px 0}.clear-all[data-v-74afc76c]{margin-left:40px;font-size:14px;cursor:pointer}.process-table[data-v-74afc76c]{margin-top:80px}.work-flow[data-v-74afc76c]{height:90%;overflow-y:scroll}\n", ""]);

// exports
